const Total = (props: { total: number }) => {
    const { total } = props
    return (
        <div className="pagination-total">
           Всего <span>{total}</span> страниц
        </div>
    )
}

export default Total
